
<template>
  <div>

    <h3 class="subtitle">{{label}}</h3>
    
    <div class="columns is-multiline is-mobile">
      <label class="product column is-one-third-mobile is-one-quarter-tablet is-half-desktop" v-for="addon in filteredAddons" :key="addon.id">
        <input :name="name" @change="updateSetting($event, addon.id)" :checked="value[addon.id]" :value="value[addon.id]" type="checkbox" />
        <b-icon v-if="value[addon.id]" type="is-dark is-medium" class="icon" pack="mdi" icon="check"></b-icon>
        <img class="module top" :src="addon.icon">
        <div class="product-title">{{addon.name}}</div>
      </label>
    </div>
    
  </div>
</template>

<script>
    
  import { mapGetters, mapActions } from "vuex";

  export default {
    
    name: 'AddonsSelector',

    props: ['multi', 'module_id', 'name', 'label', 'value','icon', 'default', 'applyTo'],

    computed : {

      ...mapGetters(['addons']),

      filteredAddons: function() {

        var vm = this;
        var compatible_addons = Object.keys(this.value);
      
        return vm.addons.filter(function(addon) {
            return compatible_addons.includes(addon.id);
        });

      }

    },

    methods:{
      updateSetting(e, name){        
        this.$emit('changeAddons', {name, value:e.target.checked});
      }
    }
  
  } 

    
</script>

<style scoped>

  [type=checkbox] {
    visibility:hidden;
    display:none;
  }

  .product{
    display: block;
    position: relative;
    text-align: center;
  }

  .product img{
    border-radius:0.4em;
  }

  .product-title{
    font-weight:bold;
  }

  .product:hover img{
      transform:scale(1.07);
      opacity:0.8;
  }

  .product:active img{
      transform:scale(1);
      opacity:1;
      
  }

  .icon{
    position: absolute;
    top:55%;
    left:50%;
    margin:-40px 0 0 -20px;
    background:#fff;
    border-radius: 50%;
    padding:0.5em;
    width:40px;
    height:40px;
    border:3px solid white;
  }

  [type=radio]:checked + figure .icon{
    display: initial;
  }

</style>
